import InvestorOffer from 'platform/investor/Company';


const routes = [
    {
        path: "/offer/:xxx",
        name: "Offer",
        icon: "ni ni-tv-2 text-primary",
        component: () => <InvestorOffer />,
        layout: "/investor",
    },
];

export default routes;